import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../action/ActionArgs'

@InputType()
export class ResetPasswordArgs extends ActionArgs {
  @Field(() => String)
  userId: string
}
